var sanitize = function (id, sanitizeSeparator, sanitizeRegExp) { return id.toLowerCase().replace(sanitizeRegExp, sanitizeSeparator); };
export var buildString = function (ids, _a) {
    var idSeparator = _a.idSeparator, sanitizeSeparator = _a.sanitizeSeparator, sanitizeRegExp = _a.sanitizeRegExp;
    return ids.reduce(function (acc, id) {
        return acc.length
            ? "" + acc + idSeparator + sanitize(id !== null && id !== void 0 ? id : '', sanitizeSeparator, sanitizeRegExp)
            : sanitize(id !== null && id !== void 0 ? id : '', sanitizeSeparator, sanitizeRegExp);
    }, '');
};
